const header_style = {
    overflow: 'hidden',
    display: 'flex',
    flexDirection : 'row',
    justifyContent: 'center'
}

const title_style = {
  
}

  export {header_style,title_style};
  